
export default function ValueProposition() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Confidence that your security posture meets or exceeds insurer expectations',
      color: 'red'
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Reduced risk of denied claims due to missing or inadequate controls',
      color: 'red'
    },
    {
      icon: 'ri-time-line',
      title: 'Faster, smoother underwriting and renewal processes',
      color: 'red'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Peace of mind knowing your practice is protected—both technically and financially',
      color: 'red'
    }
  ];

  const getColorClasses = (color: string) => {
    const colorMap: Record<string, string> = {
      red: 'bg-[#e10708]',
      teal: 'bg-[#e10708]',
      emerald: 'bg-[#e10708]',
      cyan: 'bg-[#e10708]'
    };
    return colorMap[color] || 'bg-[#e10708]';
  };

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            How We Help You Meet These Requirements
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Healthcare IT Partners specializes in helping medical practices implement the exact security controls insurers require
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-10 shadow-xl border border-gray-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            By partnering with us, healthcare organizations gain:
          </h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="flex items-start gap-4 p-6 bg-gradient-to-br from-red-50 to-red-50 rounded-xl border border-red-100 hover:shadow-lg transition-all"
              >
                <div className={`flex-shrink-0 w-12 h-12 ${getColorClasses(benefit.color)} rounded-lg flex items-center justify-center`}>
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <p className="text-gray-800 font-medium leading-relaxed pt-2">
                  {benefit.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}